import styled from "styled-components";
import { sizes } from "../../../style/util/media-query";
import { size } from "../../../style/util/size";
import { alignCenter } from "../../../style/util/align-center";
import { pulse } from "../../../style/util/animation";
import { easeOut } from "polished";

const pulseDuration = 3.5;

export const StyledSection = styled.section`
  ${size("100%")};
  position: absolute;
  padding: 0;
  overflow: hidden;
  min-height: 100vh;
`;

export const StyledFigure = styled.figure`
  ${size("100%")};
  position: relative;
  transform: scale(0.9);
  transition: transform 1s ${easeOut("quad")};
  margin: 0 auto;

  .is-active & {
    transform: none;
    transition-duration: 1s;
  }

  @media (min-aspect-ratio: 16/9) {
    width: calc(100vh * 16 / 9);
  }
`;

export const StyledHandImage = styled.img`
  ${size("95%", "auto")};
  ${alignCenter()};
  max-width: 140rem;
  opacity: 0.5;
  transform: translateX(-50%) translateY(-50%);
  transition: opacity 1s 0s, transform 1s 0s;

  .is-active & {
    opacity: 1;
  }

  @media (min-width: ${sizes.desktop}px), (min-aspect-ratio: 1 / 1) {
    width: 47%;
  }
`;

export const StyledBottleImage = styled.img`
  ${size("23.75%", "auto")};
  ${alignCenter()};
  max-width: 35rem;
  transform: translateX(-51%) translateY(-89.25%);

  @media (min-width: ${sizes.desktop}px), (min-aspect-ratio: 1 / 1) {
    width: 11.75%;
  }
`;

export const StyledBottleBlurImage = styled(StyledBottleImage)`
  filter: blur(0.5rem) brightness(2.5);
  mix-blend-mode: hard-light;
  transform: scaleX(1.1) translateX(-47%) translateY(-90%);
  opacity: 0;

  .is-active & {
    animation: ${pulse} ${pulseDuration}s infinite;
  }
`;

export const StyledSmokeImage = styled.img`
  ${size("100%", "auto")};
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-45%) translateY(-70%) scale(1.75) rotate(32deg);
  max-width: 300rem;
  opacity: 0;
  transition: opacity 1s ${easeOut("quad")}, transform 1s ${easeOut("quad")};

  .is-active & {
    opacity: 1;
    transform: translateX(-45%) translateY(-70%) scale(2) rotate(30deg);
    transition-duration: 3s, 2s;
  }

  @media (min-width: ${sizes.desktop}px), (min-aspect-ratio: 1 / 1) {
    transform: translateX(-50%) translateY(-50%) scale(0.85) rotate(-3deg);

    .is-active & {
      opacity: 1;
      transform: translateX(-50%) translateY(-50%);
    }
  }
`;
